// extracted by mini-css-extract-plugin
module.exports = {"seoFaqBlock":"FaqList_seoFaqBlock__f9CpQ","answerContent":"FaqList_answerContent__wL_3a"};